export default async () => {
  return {
    status: 200,
    pageData: {},
  };
};
